import React from 'react';
import Intro from './Intro';
import Hero from './Hero';
import Questions from './Questions';
import Submit from './Submit';
import Result from './Result';

const App = () => (
  <div id="quiz">
    <Intro />
    <Result />
    <Questions />
    <Submit />
    <Hero />
  </div>
);

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js